export default {
  data () {
    return {
      viewPorts : {
        mobile: ['xs', 'sm', 'md', 'mdplus', 'lg'], // = 0 -> 1399
        mobileSmall: ['xs', 'sm'], // = 0 -> 991
        mobileMedium: ['md'], // = 768 -> 991
        mobileMediumPlus: ['mdplus'], // = 992 -> 1199
        mobileLarge: ['lg'], // = 1200 -> 1399
        desktop: ['xl', 'xxl'] // + 1400
      }
    }
  },

  computed: {
    /*current () {
      for (let key in this.viewPorts) {
        if (key === 'mobile') continue
        if (this.viewPorts.hasOwnProperty(key)) {
          if (this.viewPorts[key].indexOf(this.$mq) !== -1) {
            console.log('currentViewPort : ', key)
            return key
          }
        }
      }
    },*/

    isViewPortMobile () {
      return this.$data.viewPorts.mobile.indexOf(this.$mq) !== -1
    },

    isViewPortMobileSmall () {
      return this.$data.viewPorts.mobileSmall.indexOf(this.$mq) !== -1
    },

    isViewPortMobileMedium () {
      return this.$data.viewPorts.mobileMedium.indexOf(this.$mq) !== -1
    },

    isViewPortMobileMediumPlus () {
      return this.$data.viewPorts.mobileMediumPlus.indexOf(this.$mq) !== -1
    },

    isViewPortMobileLarge () {
      return this.$data.viewPorts.mobileLarge.indexOf(this.$mq) !== -1
    },

    isViewPortDesktop () {
      return this.$data.viewPorts.desktop.indexOf(this.$mq) !== -1
    },

    isViewPortMinMobileLarge () {
      return this.$data.viewPorts.desktop.indexOf(this.$mq) !== -1
        ||
        this.$data.viewPorts.mobileLarge.indexOf(this.$mq) !== -1
    }
  },


}
